module.exports = __webpack_public_path__ + "static/media/forgot-password-image.187ed73a.png";